import Table from 'components/commons/table'
import ModalDelete from 'components/commons/modal-delete'
import { TABLE_SPECIAL_GIFT } from 'configs/general-settings/configTableSpecialGiftList'

export const SpecialGiftList = ({
    dataList,
    query,
    onChangeQuery,
    onDelete,
    showModalDelete,
    onShowModalDelete,
    onHideModalDelete,
    isDeleting,
    isLoading,
}) => {
    return (
        <div className={'px-9 py-4'}>
            <Table
                className={'my-3'}
                name={TABLE_SPECIAL_GIFT.name}
                columns={TABLE_SPECIAL_GIFT.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={onShowModalDelete}
                loading={isLoading}
            />
            {showModalDelete && (
                <ModalDelete
                    show={showModalDelete}
                    onHide={onHideModalDelete}
                    description={'Are You Sure Delete This?'}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
        </div>
    )
}
